import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/layouts/default.vue").then(m => m.default || m)),
  "site-default": defineAsyncComponent(() => import("/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/api/vendors/gsmaterials/app/layouts/site/default.vue").then(m => m.default || m))
}